import React from 'react';
import { Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Link, useParams } from 'react-router-dom';
import MeasurementUnitForm from '../../Components/MeasurementUnits/MeasurementUnitForm';

/**
 * Component for adding a new measurement unit
 * @returns {JSX.Element}
 */
const MeasurementUnitAdd = () => {
  const { lng } = useParams();

  return (
    <Container fluid>
      <div className="page-header columnList">
        <div className="page-title columnList">
          <h4>Add Measurement Unit</h4>
          <h6>Create a new measurement unit</h6>
        </div>
        <div className="page-btn">
          <Link to={`/${lng}/settings/measurement-units`} className="btn btn-secondary">
            <FontAwesomeIcon icon={faArrowLeft} className="me-2" /> Back to List
          </Link>
        </div>
      </div>

      <MeasurementUnitForm isEdit={false} />
    </Container>
  );
};

export default MeasurementUnitAdd;
